import React, { Component } from "react";
import SlickCarousel from "../UI/SlickCarousel/SlickCarousel";
import { clients } from "../../data";
import { connect } from "react-redux";
class OurClients extends Component {
  state = {
    clientData: null,
  };

  componentDidUpdate = () => {
    let clients = this.props.clients;
    if (clients && !this.state.clientData) {
      clients = clients.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      );

      this.setState({ clientData: clients });
    }
  };
  getSliderItems = () => {
    let sliderItems = [];
    let clientData = this.state.clientData;
    if (clientData) {
      clientData.map((sobj) => {
        sliderItems.push(
          <div>
            <a href={sobj.redirectUrl} target="_blank">
              <img
                src={sobj.imgUrl}
                alt={sobj.imgTitle}
                height="100px"
                width="100px"
              />
            </a>
          </div>
        );
      });
    }
    return sliderItems;
  };
  render() {
    if (this.props.loading) {
      return null;
    }
    let clientData = this.state.clientData;
    // if(clientData){
    //     clientData = clientData.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    // }

    return (
      <div>
        {clientData && (
          <div className="text-center m-1">
            <h2>Our Clients</h2>
          </div>
        )}
        {clientData && (
          <div className="container mt-3 mb-3">
            <SlickCarousel
              slidesToShow={clientData.length <= 6 ? clientData.length : 6}
            >
              {clientData.map((sobj) => (
                <div>
                  <a href={sobj.redirectUrl} target="_blank">
                    <img
                      src={sobj.imgUrl}
                      alt={sobj.imgTitle}
                      height="100px"
                      width="100px"
                    />
                  </a>
                </div>
              ))}
            </SlickCarousel>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.client.loading,
    clients: state.client.clientData,
  };
};

// const mapDispatchToProps = (dispatch) => {
//     return {
//         fetchHomeProducts: () => dispatch(actions.fetchHomeProducts())
//     }
// }
export default connect(mapStateToProps, null)(OurClients);
